// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { eachHourOfInterval as fn } from "../eachHourOfInterval.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const eachHourOfInterval = convertToFP(fn, 1);

// Fallback for modularized imports:
export default eachHourOfInterval;
